module.exports = __webpack_public_path__ + "static/media/logoKP.4be0edc7.png";